import { Link, NavLink } from 'react-router-dom';

export default function Header() {
  return (
    <header className="header">
      <nav aria-label="Main navigation">
        <Link to="/" className="logo-link" aria-label="vWZZ home">
          <img src="/images/logo.png" alt="vWZZ Logo" />
        </Link>
        <div className="nav-links">
          <ul>
            <li><NavLink to="/aviofp-overview">Aviofp</NavLink></li>
            <li><NavLink to="/etlb">e-TLB</NavLink></li>
            <li><NavLink to="/interep-overview">Interep</NavLink></li>
            <li><NavLink to="/screenshots">Screenshots</NavLink></li>
            <li><a href="https://mynextairline.com/airlines/vwzz" target="_blank" rel="noreferrer">MY NEXT AIRLINE</a></li>
            <li><a href="https://discord.gg/tSrdXcFBwz" target="_blank" rel="noreferrer">DISCORD</a></li>
            <li><NavLink to="/contact">CONTACT US</NavLink></li>
          </ul>
        </div>
      </nav>
    </header>
  );
}
